/**
 * Configuration centralisée des providers de paiement
 *
 * Ce fichier permet d'activer/désactiver facilement les providers
 * et de configurer leurs clés API.
 */

import { StripeProvider } from '../providers/StripeProvider';
import { PayPalProvider } from '../providers/PayPalProvider';

// Configuration des providers
// Les clés peuvent être définies ici pour le développement,
// mais devraient venir des variables d'environnement en production
const PAYMENT_CONFIG = {
  stripe: {
    enabled: true,
    // Clé publique (utilisée côté client)
    publishableKey: import.meta.env.VITE_STRIPE_KEY || 'pk_test_51Stshp10VAnngAwXo9p3jaeNiDMKJN4ElnzeLfA8zmbKf3rjW9gdVJqiOlYlmJO1RhMmOYsfP2BVRSGcSwsvEfi000F0CtWehI',
    // Clé secrète (utilisée côté serveur uniquement)
    secretKey: import.meta.env.STRIPE_SECRET_KEY || 'sk_test_51Msd7o2Lt7bn1pY02xLJQH0PN1Vr8F5K5qN6pL8sR9mM2qQ3nT7vB4cF8dH0jK1lZ3xW5yC6vB8nM2pQ4rS6tU8vW9'
  },

  paypal: {
    enabled: true,
    // Client ID PayPal (sandbox: commence par AXb..., live: commence par AX...)
    clientId: 'AXU4qui9xLi7daYKEebK7h9e3dTgytxwGRdOjXkHqWF3OOzNS5CNO7Z3ZfatsBjF8_M6KvNwqZX8YqKf',
    // Mode: 'sandbox' ou 'live'
    mode: 'sandbox',
    // Devise par défaut pour PayPal
    currency: 'USD',
    // Intent: 'capture' ou 'authorize'
    intent: 'capture'
  },

  // Futur provider pour cartes directes (visa/mastercard)
  card: {
    enabled: true
    // À implémenter plus tard
  }
};

/**
 * Factory pour créer les instances de providers
 * @returns {Array<BasePaymentProvider>} Liste des providers configurés
 */
export function createPaymentProviders() {
  const providers = [];

  // Créer Stripe provider si activé
  if (PAYMENT_CONFIG.stripe.enabled) {
    providers.push(new StripeProvider(PAYMENT_CONFIG.stripe));
  }

  // Créer PayPal provider si activé
  if (PAYMENT_CONFIG.paypal.enabled) {
    providers.push(new PayPalProvider(PAYMENT_CONFIG.paypal));
  }

  return providers;
}

/**
 * Retourne la configuration d'un provider spécifique
 * @param {string} providerId - ID du provider ('stripe', 'paypal', etc.)
 * @returns {object|null} Configuration du provider ou null
 */
export function getProviderConfig(providerId) {
  return PAYMENT_CONFIG[providerId] || null;
}

/**
 * Vérifie si un provider est activé
 * @param {string} providerId - ID du provider
 * @returns {boolean} True si le provider est activé
 */
export function isProviderEnabled(providerId) {
  return PAYMENT_CONFIG[providerId]?.enabled ?? false;
}

export { PAYMENT_CONFIG };
